import { get } from 'lodash';
import {
  ApiResponse,
  IDaypart,
  IWeekday,
  IWeekdayDaypart,
} from 'src/interfaces';

export const mapWeekdayDaypart = (response: ApiResponse): IWeekdayDaypart[] => {
  const dayparts: IDaypart[] = get(response, 'includes.dayparts.data', []);
  const weekdays: IWeekday[] = get(response, 'includes.weekdays.data', []);

  return (
    response?.data.map((weekdayDaypart: ApiResponse) => {
      return {
        ...weekdayDaypart,
        daypart: dayparts.find((item) => item.id === weekdayDaypart.daypart_id),
        weekday: weekdays.find((item) => item.id === weekdayDaypart.weekday_id),
      };
    }) ?? []
  );
};
